import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=6f4c44bb&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=6f4c44bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c44bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4c44bb')) {
      api.createRecord('6f4c44bb', component.options)
    } else {
      api.reload('6f4c44bb', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=6f4c44bb&scoped=true&", function () {
      api.rerender('6f4c44bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25WzVhz75a9O0/JS/teamMember.vue"
export default component.exports